import React from 'react';
import PropTypes from 'prop-types';

import './styles/attachment_card';

const AttachmentCard = ({assetKey, assetName, attachment, brandfolderSlug } = this.props) => {
  const assetLink = `${window.location.href.split('attachments')[0].split('/#!asset')[0]}/#!asset/${assetKey}`;
  return (
    <li className='attachment-card-component'>
      <a href={assetLink} target='_blank'>
        <div className='card-head'>
          <div className='card-head__thumbnail'>
            <img src={attachment.thumbnail_url}/>
          </div>
        </div>
        <div className='card-description'>
          <p className='attachment-name'> {attachment.filename} </p>
          <span className="attachment-info"> {attachment.extension} </span>
        </div>
      </a>
    </li>
  );
};

AttachmentCard.propTypes = {
  asset: PropTypes.object,
  assetKey: PropTypes.string.isRequired,
  attachment: PropTypes.object,
  assetName: PropTypes.string,
  brandfolderSlug: PropTypes.string
};

export default AttachmentCard;
